<template>
	<footer class="main-footer">
		<strong>Copyright &copy; 2024 <span class="text-primary">VNPT Đồng Tháp</span></strong>
	</footer>
</template>

<script>
	export default {
		name: 'TheFooter'
	}
</script>

<style></style>